import { useNavigate } from "react-router-dom";
import { seoArticles } from "@/mocks/seo-articles";

const colorMap: Record<string, string> = {
  amber: "bg-amber-100 text-amber-800",
  rose: "bg-rose-100 text-rose-800",
  emerald: "bg-emerald-100 text-emerald-800",
  red: "bg-red-100 text-red-800",
  sky: "bg-sky-100 text-sky-800",
  indigo: "bg-indigo-100 text-indigo-800",
  slate: "bg-slate-100 text-slate-800",
  teal: "bg-teal-100 text-teal-800",
  orange: "bg-orange-100 text-orange-800",
};

const iconMap: Record<string, string> = {
  amber: "ri-sun-line",
  rose: "ri-heart-line",
  emerald: "ri-star-line",
  red: "ri-alert-line",
  sky: "ri-cloud-line",
  indigo: "ri-magic-line",
  slate: "ri-shield-check-line",
  teal: "ri-rocket-line",
  orange: "ri-shopping-cart-line",
};

export default function SEOArticlesSection() {
  const navigate = useNavigate();

  return (
    <section className="w-full bg-background-100 py-14 md:py-20 px-4 md:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 mb-10 md:mb-14">
          <div>
            <h2 className="text-2xl md:text-4xl font-bold text-foreground-900 mb-2 font-heading">
              Articles <span className="italic">SEO</span>
            </h2>
            <p className="text-sm text-foreground-500 max-w-lg font-body leading-relaxed">
              Découvrez nos articles détaillés sur le hipobuy spreadsheet. Chaque article est optimisé pour vous aider à maîtriser tous les aspects du tracking et de la gestion de données.
            </p>
          </div>
          <span className="text-xs font-medium text-foreground-400 bg-background-50 px-4 py-2 rounded-full border border-background-200/60 font-body whitespace-nowrap">
            9 articles disponibles
          </span>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {seoArticles.map((article) => (
            <button
              key={article.slug}
              type="button"
              onClick={() => { navigate(`/${article.slug}`); window.scrollTo(0, 0); }}
              className="group flex flex-col bg-white rounded-2xl overflow-hidden border border-background-200/60 hover:shadow-lg transition-all duration-300 cursor-pointer text-left"
            >
              {/* Image */}
              <div className="w-full aspect-[3/2] overflow-hidden relative">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  width={600}
                  height={400}
                />
                <div className="absolute top-3 left-3">
                  <span className={`inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-xs font-semibold font-body ${colorMap[article.color] || "bg-background-100 text-foreground-600"}`}>
                    <span className="w-3.5 h-3.5 flex items-center justify-center">
                      <i className={iconMap[article.color] || "ri-file-text-line"} />
                    </span>
                    Article
                  </span>
                </div>
              </div>

              {/* Content */}
              <div className="p-5 flex flex-col flex-1">
                <p className="text-xs text-foreground-400 mb-1 font-body">{article.date}</p>
                <h3 className="text-base font-bold text-foreground-900 group-hover:text-primary-600 transition-colors font-heading leading-snug mb-2 line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed font-body line-clamp-2 flex-1">
                  {article.excerpt}
                </p>
                <div className="flex items-center gap-1 mt-4 text-primary-500 text-xs font-medium font-body">
                  <span>Lire l'article complet</span>
                  <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform" />
                </div>
              </div>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}